export default `
<div>
	<var data-echo-pd="label"></var>
	<var data-echo-pd="text"></var>
</div>
`.replace(/\t|\n/g, "");
